import CityLandingPage from './page';

const fortalezaData = {
  cityName: 'Fortaleza',
  state: 'CE',
  slug: 'palestra-silenciosa-fortaleza',
  coordinates: {
    lat: -3.7172,
    lng: -38.5433,
  },
  phone: '(11) 91777-6227',
  localKeywords: [
    'palestra silenciosa fortaleza',
    'silent conference fortaleza',
    'aluguel fones sem fio fortaleza',
    'eventos corporativos fortaleza',
    'tradução simultânea fortaleza',
    'silent disco fortaleza',
  ],
  heroTitle: 'palestra silenciosa fortaleza',
  heroSubtitle: 'Tecnologia de áudio sem fio premium para eventos corporativos, conferências multilíngues e workshops em Fortaleza e Ceará. Palestra silenciosa com suporte técnico especializado.',
  localStats: {
    clients: '200+',
    satisfaction: '98%',
  },
  localTestimonials: [],
  localFAQs: [
    {
      question: 'A STIB atende eventos em Fortaleza e no interior do Ceará?',
      answer: 'Sim! Atendemos Fortaleza, Região Metropolitana e interior do Ceará. Para eventos em cidades como Juazeiro do Norte, Sobral e Crato, entre em contato para verificar disponibilidade e condições de deslocamento.',
    },
    {
      question: 'Quais espaços de eventos em Fortaleza são compatíveis com palestra silenciosa?',
      answer: 'A palestra silenciosa funciona em qualquer espaço: Centro de Eventos do Ceará, Beach Park, Gran Marquise, Iate Clube de Fortaleza, espaços na Beira Mar e qualquer outro local. Não há restrições de ambiente.',
    },
    {
      question: 'Qual o prazo para contratar palestra silenciosa em Fortaleza?',
      answer: 'Recomendamos pelo menos 20 dias de antecedência para eventos em Fortaleza. Para eventos de grande porte, sugerimos 30 dias. Também atendemos demandas urgentes conforme disponibilidade.',
    },
    {
      question: 'A palestra silenciosa funciona para eventos na praia em Fortaleza?',
      answer: 'Sim! Eventos na Beira Mar, Meireles, Cumbuco e outras praias do Ceará são casos de uso ideais. Sem caixas de som, sem poluição sonora, sem restrições de horário — perfeito para eventos à beira-mar.',
    },
    {
      question: 'A STIB oferece tradução simultânea para eventos internacionais em Fortaleza?',
      answer: 'Sim. Nosso sistema suporta até 10 idiomas simultâneos sem necessidade de cabines de tradução. Ideal para eventos internacionais, congressos científicos e conferências multilíngues em Fortaleza.',
    },
  ],
  seoTitle: 'Palestra Silenciosa Fortaleza | Aluguel Fones Sem Fio CE | STIB',
  seoDescription: 'Palestra silenciosa Fortaleza: aluguel de fones sem fio para eventos corporativos, conferências e workshops no Ceará. Suporte técnico especializado, equipamentos premium. Orçamento: (11) 91777-6227.',
};

export default function FortalezaLandingPage() {
  return <CityLandingPage cityData={fortalezaData} />;
}
